import React from "react";
import styles from "./BottomSubButton.module.less"
import { Button } from "antd";

const BottomSubButton = (item:any) => {
  const {positionType} = item
  return <>
    <div className={styles.bottom_wapper} style={positionType === "drag" ?{position:"initial"}:{}}>
      <div className={styles.bottom_inner_wapper}>
        <Button style={{marginRight:"20px"}} onClick={()=>{history.go(-1)}}>取消</Button>
        <Button type="primary" htmlType="submit">提交</Button>
      </div>
    </div>
  </>
}

export default BottomSubButton